<script>
import {useProductStore} from "@js/store/ProductStore.js";
import {useCartStore} from "@js/store/CartStore.js";
import IconPlus from "@js/components/Icons/IconPlus.vue";
import IconMinus from "@js/components/Icons/IconMinus.vue";
import {useThemeStore} from "@js/store/ThemeStore.js";
import IconCart from "@js/components/Icons/IconCart.vue";
import IconCartPlus from "@js/components/Icons/IconCartPlus.vue";
import {Link} from "@inertiajs/vue3";

export default {
    name: "ProductAddToCart",
    components: {IconCartPlus, IconCart, IconMinus, IconPlus, Link},
    data() {
        return {
            count: 1,
        }
    },
    watch: {
        count: function (newCount) {
            if (newCount < 1) {
                this.count = 1
            }
            if (newCount > 999) {
                this.count = 999
            }
        }
    },
    methods: {
        plus() {
            this.count++
        },
        minus() {
            this.count--
        },
        addToCart() {
            this.cartStore.addProductToCart(this.productStore.product, this.count)
            this.themeStore.addToast(this.productStore.product.name + ' добавлено в корзину', 'success');

            this.count = 1
        }
    },
    setup() {
        const themeStore = useThemeStore()
        const productStore = useProductStore()
        const cartStore = useCartStore()

        return {productStore, cartStore, themeStore}
    }
}
</script>

<template>
    <div>
        <div class="relative flex items-center max-w-[8rem] mb-5">
            <button type="button" aria-label="Меньше"
                    @click.prevent="minus()"
                    class="bg-gray-100 hover:bg-gray-200 border border-gray-300 rounded-s-lg p-3 h-11 focus:ring-gray-100 focus:ring-2 focus:outline-none">
                <IconMinus class="h-2.5 w-2.5"/>
            </button>
            <input type="number" v-model="count"
                   class="bg-gray-50 border-x-0 border-gray-300 h-11 text-center text-gray-900 text-sm block w-full py-2.5 focus:border-gray-300 focus:ring-0"
                   placeholder="0"/>
            <button type="button" aria-label="Больше"
                    @click.prevent="plus()"
                    class="bg-gray-100 hover:bg-gray-200 border border-gray-300 rounded-e-lg p-3 h-11 focus:ring-gray-100 focus:ring-2 focus:outline-none">
                <IconPlus class="h-2.5 w-2.5"/>
            </button>
        </div>
        <div class="flex flex-col md:flex-row gap-5">
            <button type="button" @click.prevent="addToCart"
                    class="group inline-flex justify-center items-center text-white hover:text-indigo-600 border-2 border-indigo-600 bg-indigo-600 hover:bg-transparent font-medium rounded-lg text-sm px-5 py-2 focus:outline-none transition">
                <IconPlus class="w-3 h-3 me-2"/>
                Добавить в корзину
                <span v-if="count > 1" class="ms-1">
                ({{ count }})
            </span>
            </button>
            <Link :href="route('cart')"
                  class="group inline-flex justify-center items-center text-indigo-600 hover:text-white border-2 border-indigo-600 bg-transparent hover:bg-indigo-600 font-medium rounded-lg text-sm px-5 py-2 focus:outline-none transition">
                <IconCart class="w-5 h-5 me-2"/>
                Перейти в корзину
            </Link>
        </div>

    </div>
</template>

<style scoped lang="scss">

</style>
